module.exports = __webpack_public_path__ + "img/zp-img.68681d78.png";